import SoftwaresFolderIcon from "@svg/access/SoftwaresFolder";
import { SoftwarePerquisite } from "@types";
import { isThisStringHtmlCode } from "@utils/helpers";
import { FC } from "react";
import parse from "html-react-parser";
import { commonHtmlParserOptions } from "@utils/html-parser";
import LayersIcon from "@svg/new-design/layers";

interface Props {
  items: SoftwarePerquisite[];
}

const PrerequestApps: FC<Props> = ({ items }) => {
  const prepareItem = (items || []).filter((preItem) => preItem.title !== "");
  const isHtml = prepareItem[0]?.title
    ? isThisStringHtmlCode(prepareItem[0]?.title)
    : false;
  if (!prepareItem?.length) return null;
  return (
    <div className="flex w-full   flex-col py-6">
      <h4 className="headline-sm mb-5 sm:headline-md text-fds-primary">
        نرم‌افزارهای مرتبط
      </h4>
      {isHtml ? (
        <div className="course-html-content text-fds-secondary body-sm md:body-md lg:body-lg">
          {parse(
            `<div>${prepareItem[0]?.title}</div>`,
            commonHtmlParserOptions()
          )}
        </div>
      ) : (
        <div className="flex w-full flex-col gap-1.5">
          {prepareItem.map((prerequest, idx) => {
            return (
              <div
                key={idx}
                className="  gap-3 flex items-center text-fds-primary rounded-full"
              >
                <LayersIcon className="lg:h-5 lg:w-5 w-4 h-4" />
                <p className="title-sm lg:title-lg">{prerequest.title}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PrerequestApps;
